// extracted by mini-css-extract-plugin
export var filterIncDec = "_bo-0";
export var leftBorder = "_bo-1";
export var rightBorder = "_bo-2";
export var stringInput = "_bo-3";